module.exports = __webpack_public_path__ + "img/whyluckperms-5.c9c8aaf4.png";